import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;

    margin-block: var(--mobile-widget-gap, 16px);
    padding-block: var(--widget-extra-padding, 12px);
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block: var(--desktop-widget-gap, 18px);
  }
`;
